import { Injectable } from '@angular/core';
import { ServiceBase, OrigamiResponse } from './base/service.base';
import { Observable } from 'rxjs';
import { Topic } from '../utils/topic-utils';

export namespace CalendarTaskServiceModel {
  export interface TaskView {
    EntitiesCount: number;
    ViewFilterDisplayName: string;
    ViewFilterId: string;
    ViewMode: number;
  }

  export interface Task extends Topic {
    Attachments: { FileId?: number; FileName: string; FileSize?: number; FileToken?: string }[];
    LastUpdatedBy: number;
    LastUpdatedDate: string;
    LinkedDocuments: Topic[];
  }

  export interface TaskResult {
    CalendarTasks: Task[];
    TotalRowCount: number;
  }
}

export namespace CalendarTaskServiceOptions {
  export interface GetCalendarTaskViews {
    siteId: number;
    dataRoomId?: number;
    viewMode?: number;
  }

  export interface GetCalendarTasks {
    dataRoomId?: number;
    limit?: number;
    siteId: number;
    start?: number;
    viewFilter: string;
    viewMode: number;
  }
}

@Injectable()
export class CalendarTaskService extends ServiceBase {
  serviceUrl = 'CalendarTaskService.svc';

  getCalendarTaskViews(
    body: CalendarTaskServiceOptions.GetCalendarTaskViews,
  ): Observable<OrigamiResponse<CalendarTaskServiceModel.TaskView[]>> {
    return this.origamiPost('/GetCalendarTaskViews', body, null, null, true);
  }

  getCalendarTasks(
    params: CalendarTaskServiceOptions.GetCalendarTasks,
    ...options
  ): Observable<OrigamiResponse<CalendarTaskServiceModel.TaskResult>> {
    return this.origamiPost('/GetCalendarTasks', params, null, null, true);
  }

  getCalendarTask(params: {
    siteId: number;
    taskTopicId: number;
  }): Observable<OrigamiResponse<CalendarTaskServiceModel.Task>> {
    return this.origamiPost('/GetCalendarTask', params, null, null, true);
  }

  createCalendarTasks(body) {
    return this.origamiPost('/CreateCalendarTask', body, null, null, true);
  }

  modifyCalendarTask(body) {
    return this.origamiPost('/ModifyCalendarTask', body, null, null, true);
  }

  deleteCalendarTask(params: {
    siteId: number;
    taskTopics: { TopicId: number; TopicName: string }[];
  }): Observable<OrigamiResponse<any[]>> {
    return this.origamiPost('/DeleteCalendarTask', params, null, null, true);
  }
}
